/*
 * Cart drawer Subscribe & Save offer (Intelligems test), see snippets/cart-subscribe-upgrade.liquid.
 * Switches one cart line between its one-time variant and the matching subscription variant
 * (with its Skio selling plan), leaving every other line alone, then redraws the drawer.
 * The new line is added before the old one is removed, so a failure never loses the item.
 */
(function () {
  if (window.cartSubscribeUpgrade) return;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  async function cartRequest(path, body) {
    const response = await fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || data.message || 'Cart update failed');
    return data;
  }

  function renderDrawer(state) {
    const drawerInner = document.querySelector('#CartDrawer .drawer__inner') || document.getElementById('CartDrawer');
    const html = state.sections && state.sections['cart-drawer'];
    if (drawerInner && html) {
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.drawer__inner');
      if (fresh) drawerInner.innerHTML = fresh.innerHTML;
    }
    const bubble = document.getElementById('cart-icon-bubble');
    const bubbleHtml = state.sections && state.sections['cart-icon-bubble'];
    if (bubble && bubbleHtml) {
      const freshBubble = new DOMParser().parseFromString(bubbleHtml, 'text/html').querySelector('.shopify-section');
      if (freshBubble) bubble.innerHTML = freshBubble.innerHTML;
    }
    const drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.classList.toggle('is-empty', state.item_count === 0);
    const items = document.querySelector('cart-drawer-items');
    if (items && typeof items.upsellsliderInit === 'function') items.upsellsliderInit();
    const swicth = document.querySelector('#CartDrawer envelop-swicth');
    if (swicth && typeof swicth.connectedCallback === 'function') swicth.connectedCallback();
  }

  const SKELETON_MIN_MS = 700;
  const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  function showSkeleton(row) {
    if (!row) return null;
    const strip = row.nextElementSibling && row.nextElementSibling.classList.contains('sub-swap-strip') ? row.nextElementSibling : null;
    const skeleton = document.createElement('div');
    skeleton.className = 'sub-swap-skeleton';
    skeleton.setAttribute('aria-hidden', 'true');
    skeleton.innerHTML =
      '<span class="sub-swap-skeleton__media"></span>' +
      '<span class="sub-swap-skeleton__lines">' +
      '<span class="sub-swap-skeleton__bar sub-swap-skeleton__bar--title"></span>' +
      '<span class="sub-swap-skeleton__bar"></span>' +
      '<span class="sub-swap-skeleton__bar sub-swap-skeleton__bar--short"></span>' +
      '<span class="sub-swap-skeleton__bar sub-swap-skeleton__bar--pill"></span>' +
      '</span>';
    row.classList.add('is-swapping');
    row.setAttribute('aria-busy', 'true');
    row.appendChild(skeleton);
    strip && strip.classList.add('is-swapping');
    const live = document.getElementById('CartDrawer-LiveRegionText');
    if (live) live.textContent = 'Updating your cart';
    return () => {
      skeleton.remove();
      row.classList.remove('is-swapping');
      row.removeAttribute('aria-busy');
      strip && strip.classList.remove('is-swapping');
    };
  }

  async function swap(control) {
    const d = control.dataset;
    const upgrading = d.subSwap === 'upgrade';
    const item = { id: Number(d.toVariant), quantity: Number(d.quantity) || 1 };
    if (upgrading) {
      item.selling_plan = Number(d.sellingPlan);
      item.properties = { _swap_from: d.fromVariant, _swap_source: 'cart-' + d.design };
    }

    const container = control.closest('.sub-swap');
    container && container.classList.add('is-loading');
    control.disabled = true;
    const hideSkeleton = showSkeleton(control.closest('.cart-item'));

    try {
      const [state] = await Promise.all([
        cartRequest('cart/add.js', { items: [item] }).then(() =>
          cartRequest('cart/change.js', {
            id: d.lineKey,
            quantity: 0,
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname,
          })
        ),
        wait(SKELETON_MIN_MS),
      ]);
      renderDrawer(state);
      document.dispatchEvent(
        new CustomEvent('cart-subscribe-upgrade:change', { detail: { action: d.subSwap, design: d.design } })
      );
      if (window.giftProductManager && typeof window.giftProductManager.debouncedCheck === 'function') {
        window.giftProductManager.debouncedCheck();
      }
    } catch (error) {
      console.error('[cart-subscribe-upgrade]', error);
      hideSkeleton && hideSkeleton();
      container && container.classList.remove('is-loading');
      control.disabled = false;
      if (control.type === 'checkbox') control.checked = !upgrading;
    }
  }

  // Capture phase, so the drawer's own change handler (which treats any input as a quantity) never sees it.
  document.addEventListener(
    'change',
    (event) => {
      const control = event.target.closest('input[data-sub-swap]');
      if (!control) return;
      event.stopPropagation();
      swap(control);
    },
    true
  );
  document.addEventListener('click', (event) => {
    const control = event.target.closest('button[data-sub-swap]');
    if (control) swap(control);
  });

  window.cartSubscribeUpgrade = { swap };
})();
